import { createFileRoute } from "@tanstack/react-router";
import { AgentPage } from "@/components/agents/agent-page";
import { parseRunId } from "@/components/agents/config-prefill";

function optionalString(value: unknown): string | undefined {
	return typeof value === "string" && value ? value : undefined;
}

export const Route = createFileRoute("/$owner/agents/$agentId/")({
	// `?run_id=42` is the Slack config-approval deep link: it prefills the held
	// builder proposal for review (non-numeric values are dropped). `?skill=` and
	// `?guardrail=` open that row in place.
	validateSearch: (
		search: Record<string, unknown>,
	): { run_id?: number; skill?: string; guardrail?: string } => ({
		run_id: parseRunId(search.run_id),
		skill: optionalString(search.skill),
		guardrail: optionalString(search.guardrail),
	}),
	component: AgentPageRoute,
});

function AgentPageRoute() {
	const { owner, agentId } = Route.useParams();
	const { run_id, skill, guardrail } = Route.useSearch();
	return (
		<AgentPage
			owner={owner}
			agentId={agentId}
			runId={run_id}
			expandedSkill={skill}
			expandedGuardrail={guardrail}
		/>
	);
}
